import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Stack,
  Modal,
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";

type Props = {
  open: boolean;
  handleClose: Function;
};

const NoPrimarySalesModal: React.FC<Props> = ({ open, handleClose }) => {
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    borderRadius: "22px",
    boxShadow: 24,
    p: 4,
  };
  const data: { code: number; firm_name: string }[] = [
    {
      code: 3000473715,
      firm_name: "D.S.MEDICAL AGENCY",
    },
    {
      code: 3000473715,
      firm_name: "D.S.MEDICAL AGENCY",
    },
    {
      code: 3000473715,
      firm_name: "D.S.MEDICAL AGENCY",
    },
    {
      code: 3000473715,
      firm_name: "D.S.MEDICAL AGENCY",
    },
    {
      code: 3000473715,
      firm_name: "D.S.MEDICAL AGENCY",
    },
  ];
  return (
    <>
      <Modal open={open} onClose={() => handleClose()}>
        <Box sx={style}>
          <Stack direction="row" justifyContent="space-between" mb={2}>
            <Typography variant="h6">Customer with No Primary Sales</Typography>
            <Button
              onClick={() => handleClose()}
              sx={{ height: "30px", width: "10px" }}
            >
              <CloseIcon fontSize="small" color="error" />
            </Button>
          </Stack>
          <Stack maxHeight={"40vh"} overflow={"scroll"}>
            <Paper sx={{ border: "1px solid #dddddd" }}>
              <TableContainer>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Code</TableCell>
                      <TableCell>Customer</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((data) => (
                      <TableRow>
                        <TableCell>{data.code}</TableCell>
                        <TableCell>{data.firm_name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default NoPrimarySalesModal;
